import { useRef } from "react";
import { motion, useInView } from "framer-motion";

/** Word/line-by-line masked reveal used for the kinetic hero. */
export const MaskReveal = ({ children, delay = 0, className = "" }) => {
  return (
    <span className="reveal-mask">
      <motion.span
        className={`block ${className}`}
        initial={{ y: "110%" }}
        animate={{ y: "0%" }}
        transition={{ duration: 0.9, delay, ease: [0.16, 1, 0.3, 1] }}
      >
        {children}
      </motion.span>
    </span>
  );
};

/** Generic scroll-triggered reveal for sections. */
export const Reveal = ({ children, delay = 0, y = 28, className = "", ...rest }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-80px" });
  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, y }}
      animate={inView ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 0.7, delay, ease: [0.16, 1, 0.3, 1] }}
      className={className}
      {...rest}
    >
      {children}
    </motion.div>
  );
};
